import { render, staticRenderFns } from "./GenelIstatistikGrafikInfo.vue?vue&type=template&id=246668de&scoped=true"
import script from "./GenelIstatistikGrafikInfo.vue?vue&type=script&lang=ts"
export * from "./GenelIstatistikGrafikInfo.vue?vue&type=script&lang=ts"
import style0 from "./GenelIstatistikGrafikInfo.vue?vue&type=style&index=0&id=246668de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246668de",
  null
  
)

export default component.exports